import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { COMPANY_INFO, CTA_URL, IMAGES, NAV_LINKS } from "../constants";

const Navbar: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`fixed w-full z-50 transition-all duration-300 ${
        isScrolled
          ? "bg-surface/95 backdrop-blur-md border-b border-border-strong shadow-sm"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex-shrink-0 flex items-center">
            <a
              href="#inicio"
              className="flex items-center focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2"
            >
              <img
                src={IMAGES.logo}
                alt={`${COMPANY_INFO.name} Logo`}
                className="h-11 w-auto"
              />
            </a>
          </div>

          <nav className="hidden md:flex items-center space-x-8">
            {NAV_LINKS.map((link) => (
              <a
                key={link.id}
                href={link.href}
                className={`relative font-semibold uppercase tracking-wider text-sm link-underline focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 px-1 transition-colors ${
                  isScrolled
                    ? "text-text-primary/90 hover:text-primary"
                    : "text-white/90 hover:text-white"
                }`}
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="hidden md:flex items-center">
            <a
              href={CTA_URL}
              className="bg-primary hover:bg-secondary text-white px-6 py-2.5 font-semibold uppercase tracking-wide text-sm shadow-sm hover:shadow-md transition-all duration-200 btn-press focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2"
            >
              Solicitar acceso
            </a>
          </div>

          <div className="md:hidden flex items-center">
            <button
              type="button"
              className={`p-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 transition-colors ${
                isScrolled
                  ? "text-text-primary hover:text-primary"
                  : "text-white hover:text-white/80"
              }`}
              onClick={() => setIsOpen(!isOpen)}
              aria-expanded={isOpen}
              aria-controls="mobile-menu"
              aria-label={isOpen ? "Cerrar menú" : "Abrir menú"}
            >
              {isOpen ? (
                <X className="h-6 w-6" aria-hidden="true" />
              ) : (
                <Menu className="h-6 w-6" aria-hidden="true" />
              )}
            </button>
          </div>
        </div>
      </div>

      <div
        id="mobile-menu"
        className={`md:hidden overflow-hidden transition-all duration-300 ${
          isOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div
          className={`px-4 pt-2 pb-4 backdrop-blur-md border-t ${
            isScrolled
              ? "bg-surface/95 border-border-strong"
              : "bg-text-primary/80 border-white/10"
          }`}
        >
          {NAV_LINKS.map((link) => (
            <a
              key={link.id}
              href={link.href}
              onClick={() => setIsOpen(false)}
              className={`block px-3 py-3 font-medium uppercase tracking-wide text-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 transition-colors ${
                isScrolled
                  ? "text-text-primary hover:text-primary"
                  : "text-white/90 hover:text-white"
              }`}
            >
              {link.label}
            </a>
          ))}
          <a
            href={CTA_URL}
            onClick={() => setIsOpen(false)}
            className="mt-4 block bg-primary text-white px-6 py-3 font-semibold uppercase tracking-wide text-sm text-center shadow-sm hover:shadow-md transition-all duration-200 btn-press focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2"
          >
            Solicitar acceso
          </a>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
